export default __webpack_public_path__ + "images/fb0d1f17386ce63bc161a05d44b89ab2-pride_small.webp";